export default __webpack_public_path__ + "static/media/warningIcon.474f0b4e.svg";